import { ArchiveFilterValue } from 'components/new-ui/composed/archive-filter/ArchiveFilter';
import { TeamActions } from './actionTypes';
import {
    activateTeam,
    addIndividualToTeam,
    deactivateTeam,
    getTeamById,
    listTeamInvoices,
    listTeamManifests,
    listTeamJobs,
    listTeams,
    removeIndividualFromTeam,
    updateTeam,
} from './client';
import { AddTeamMemberPayload, CreateUpdateTeamPayload, GetTeamsParams } from './types';

export const doGetTeams: Function = (params: GetTeamsParams) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.LIST_TEAMS_REQUEST });
    try {
        const response = await listTeams(params);

        dispatch({
            type: TeamActions.LIST_TEAMS_SUCCESS,
            payload: response,
        });

        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.LIST_TEAMS_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doGetTeamById: Function = (teamId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.GET_TEAM_BY_ID_REQUEST });
    try {
        const response = await getTeamById(teamId);

        dispatch({
            type: TeamActions.GET_TEAM_BY_ID_SUCCESS,
            payload: response,
        });

        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.GET_TEAM_BY_ID_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doUpdateTeam: Function =
    (teamId: string, payload: CreateUpdateTeamPayload) => async (dispatch: Function) => {
        dispatch({ type: TeamActions.UPDATE_TEAM_REQUEST });
        try {
            const response = await updateTeam(teamId, payload);
            dispatch({
                type: TeamActions.UPDATE_TEAM_SUCCESS,
                payload: response,
            });
            return response;
        } catch (e: any) {
            dispatch({ type: TeamActions.UPDATE_TEAM_ERROR, error: e?.response?.data });
            throw e;
        }
    };

export const doActivateTeam: Function = (teamId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.ACTIVATE_TEAM_REQUEST });
    try {
        const response = await activateTeam(teamId);
        dispatch({
            type: TeamActions.ACTIVATE_TEAM_SUCCESS,
            payload: response,
        });
        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.ACTIVATE_TEAM_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doDeactivateTeam: Function = (teamId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.DEACTIVATE_TEAM_REQUEST });
    try {
        const response = await deactivateTeam(teamId);
        dispatch({
            type: TeamActions.DEACTIVATE_TEAM_SUCCESS,
            payload: response,
        });
        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.DEACTIVATE_TEAM_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doAddTeamMember: Function =
    ({ teamId, individualId, role }: AddTeamMemberPayload) =>
    async (dispatch: Function) => {
        dispatch({ type: TeamActions.ADD_TEAM_MEMBER_REQUEST });
        try {
            const updatedTeam = await addIndividualToTeam({ teamId, individualId, role });
            dispatch({
                type: TeamActions.ADD_TEAM_MEMBER_SUCCESS,
                payload: updatedTeam,
            });
            return updatedTeam;
        } catch (e: any) {
            dispatch({ type: TeamActions.ADD_TEAM_MEMBER_ERROR, error: e?.response?.data });
            throw e;
        }
    };

export const doRemoveTeamMember: Function = (teamId: string, individualId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.REMOVE_TEAM_MEMBER_REQUEST });
    try {
        const updatedTeam = await removeIndividualFromTeam(teamId, individualId);
        dispatch({
            type: TeamActions.REMOVE_TEAM_MEMBER_SUCCESS,
            payload: updatedTeam,
        });
        return updatedTeam;
    } catch (e: any) {
        dispatch({ type: TeamActions.REMOVE_TEAM_MEMBER_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doSetArchivationStatusFilter: Function = (status: ArchiveFilterValue) => (dispatch: Function) =>
    dispatch({
        type: TeamActions.SET_ARCHIVATION_STATUS_FILTER,
        payload: status,
    });

export const doGetTeamInvoicesCount: Function = (teamId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.GET_TEAM_INVOICES_COUNT_REQUEST });
    try {
        const response = await listTeamInvoices(teamId, { archived: false });
        dispatch({
            type: TeamActions.GET_TEAM_INVOICES_COUNT_SUCCESS,
            payload: { teamId, count: response.total },
        });
        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.GET_TEAM_INVOICES_COUNT_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doGetTeamManifestsCount: Function = (teamId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.GET_TEAM_MANIFESTS_COUNT_REQUEST });
    try {
        const response = await listTeamManifests(teamId);
        dispatch({
            type: TeamActions.GET_TEAM_MANIFESTS_COUNT_SUCCESS,
            payload: { teamId, count: response.total },
        });
        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.GET_TEAM_MANIFESTS_COUNT_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doGetTeamJobsCount: Function = (teamId: string) => async (dispatch: Function) => {
    dispatch({ type: TeamActions.GET_TEAM_JOBS_COUNT_REQUEST });
    try {
        const response = await listTeamJobs(teamId);
        dispatch({
            type: TeamActions.GET_TEAM_JOBS_COUNT_SUCCESS,
            payload: { teamId, count: response.total },
        });
        return response;
    } catch (e: any) {
        dispatch({ type: TeamActions.GET_TEAM_JOBS_COUNT_ERROR, error: e?.response?.data });
        throw e;
    }
};
